const BaseComponent = require('base/base-component');

let index = 0;
let timeOuter = null;
class investmentBanner extends BaseComponent {
  constructor () {
    super();
    $('#containerPic li')
      .eq(0)
      .css('display', 'block');
    this.autoPlay();
    this.markClick();
  }

  autoPlay () {
    const that = this;
    timeOuter = setInterval(() => {
      that.playFade();
    }, 3000);
    // 鼠标移入移出效果
    $('#container').hover(
      () => {
        clearInterval(timeOuter);
      },
      () => {
        timeOuter = setInterval(() => {
          that.playFade();
        }, 3000);
      }
    );
  }

  // 渲染
  renderLi (index) {
    $('#position li')
      .eq(index)
      .addClass('cur')
      .siblings()
      .removeClass('cur');
    $('.pic li')
      .eq(index)
      .fadeIn(500)
      .siblings()
      .fadeOut(500);
  }

  // 淡入淡出
  playFade () {
    this.renderLi(index);
    index += 1;
    if (index > 2) {
      index = 0;
    }
  }

  markClick () {
    $('#position li').on('click', (e) => {
      const index = $(e.target).data('index');
      this.renderLi(index);
    });
  }
}
module.exports = investmentBanner;
